export interface AvatarUploadResult {
  ok: boolean;
  url: string | null;
  reason?:
    | 'unsupported'
    | 'too_large'
    | 'invalid_type'
    | 'resize_failed'
    | 'no_supabase'
    | 'upload_failed';
}

export const AVATAR_SIZE_PX = 96;
export const AVATAR_MAX_INPUT_BYTES = 5 * 1024 * 1024;
export const AVATAR_ALLOWED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/webp',
  'image/gif'
];